import { FieldFilterType } from "../../../../base/types";
import { ITableLookup } from "../../../../base/models";
import { useAuth } from "../../../../../modules/auth";
import { useCallback } from "react";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";
import { useParams } from "react-router-dom";

export const useGetLookupLabel = () => {
    const { user } = useAuth();
    const { siteId } = useParams()
    const [readRecords, { isLoading }] = useLazyReadMultipleQuery()

    const getLookupLabel = useCallback(({ value, tableLookup }: {
        value?: string,
        tableLookup?: ITableLookup
    }): Promise<string> => {
        if (!tableLookup || !value)
            return Promise.reject('Invalid parameters');

        const { tableId, idField, displayField } = tableLookup;
        if (!tableId || !idField || !displayField || !siteId)
            return Promise.reject('Invalid parameters');

        return readRecords({
            userId: user?.userId || '',
            portalId: siteId,
            tableId,
            fieldList: [idField, displayField],
            recordLimit: 1,
            filters: [
                { group: 0, filters: tableLookup.filters || [] },
                { group: 1, filters: [{ field: idField, type: FieldFilterType.Const, value }] }
            ],
        })
            .unwrap()
            .then(data => {
                const record = data.records.find(p => p[idField!] === value)
                if (record)
                    return Promise.resolve(record[displayField!]);

                return Promise.resolve('')
            })

        // eslint-disable-next-line
    }, [user])

    return { getLookupLabel, isLoading }
}